var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"unstyled",on:{"mouseenter":function($event){_vm.msg && _vm.msgs[_vm.msg] && _vm.setMessage()},"mouseleave":function($event){return _vm.eraseMessage()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }